import { CountryCodes } from 'constants/Countries'
import { SelfCategorisationThreshold, YesNoValues } from './constants'
import { HighNetWorthFormData } from './schemas/highNetWorthSchema'
import { RestrictedFormData } from './schemas/restrictedSchema'
import { SophisticatedFormData } from './schemas/sophisticatedSchema'

export const getIsFinpromCountry = (countryCode: string): boolean => {
  return countryCode === CountryCodes.UK
}

/**
 * Gets the pass result for the answers provided in the Restricted investor form
 * @returns {Boolean} If result is pass true is returned
 */
export const getRestrictedFormResult = (answers: RestrictedFormData): boolean => {
  const isAnswersYesToAll =
    answers?.isPercentageInvestedLess === YesNoValues.YES &&
    answers?.isPercentageIntendedToInvestLess === YesNoValues.YES
  if (!isAnswersYesToAll) return false
  const isPercentageValuesCorrect =
    Number(answers?.percentageInvested) < SelfCategorisationThreshold.INVESTMENT_PERCENTAGE &&
    Number(answers?.percentageIntendedToInvest) < SelfCategorisationThreshold.INVESTMENT_PERCENTAGE
  if (!isPercentageValuesCorrect) return false
  return answers?.isRiskAccepted
}

/**
 * Gets the pass result for the answers provided in the High Net Worth investor form
 * @returns {Boolean} If result is pass true is returned
 */
export const getHighNetWorthFormResult = (answers: HighNetWorthFormData): boolean => {
  const isIncomeMore = answers?.isAnnualIncomeMore === YesNoValues.YES
  const isAssetsMore = answers?.isNetAssetsMore === YesNoValues.YES
  const isAnswersYesToAny = isIncomeMore || isAssetsMore
  if (!isAnswersYesToAny) return false
  if (isIncomeMore && Number(answers?.annualIncomeValue) < SelfCategorisationThreshold.INCOME) {
    return false
  }
  if (isAssetsMore && Number(answers?.netAssetsValue) < SelfCategorisationThreshold.NET_ASSETS) {
    return false
  }
  return answers?.isRiskAccepted
}

/**
 * Gets the pass result for the answers provided in the Sophisticated investor form
 * @returns {Boolean} If result is pass true is returned
 */
export const getSophisticatedFormResult = (answers: SophisticatedFormData): boolean => {
  if (answers?.isCertificateReceived !== YesNoValues.YES) return false
  if (!answers?.authorisedFirm) return false
  return answers?.isRiskAccepted
}
